import { RefObject } from 'react';

import { useImportHubV2 } from '../../hooks/ff/index.js';
import { ContextFieldsV1 } from './ContextFieldsV1.jsx';
import { ContextFieldsV2 } from './ContextFieldsV2.jsx';

type ContextFieldsProps = {
  ref: RefObject<HTMLDivElement | null>;
  isUploadStep: boolean;
};

export const ContextFields = ({ ref, isUploadStep }: ContextFieldsProps) => {
  const isImportHubV2Enabled = useImportHubV2();

  if (isImportHubV2Enabled) {
    return <ContextFieldsV2 ref={ref} isUploadStep={isUploadStep} />;
  }

  return <ContextFieldsV1 ref={ref} isUploadStep={isUploadStep} />;
};
